module.exports = __webpack_public_path__ + "media/images/icons/bids-d804f954259032820c01f3d101a26480.svg";